import script from "./PageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__